import React from 'react';
import { useTranslate } from '@bynder/localization';
import { IconTag } from '@bynder/icons';
import { calculateHeightStyle } from './calculateHeightStyle';
import { SearchResults } from '../../../types';
import { isReactAssetOverviewActive } from '../helpers/searchUtils';
import { iconSizeMedium } from '../../../helpers/iconSizes';

interface Props {
	searchTerm: string;
	results: SearchResults;
	clearSearchTerm: () => void;
}

export function GroupTags({ searchTerm, results, clearSearchTerm }: Props) {
	const { translate } = useTranslate();
	const { tags } = results;

	const emitTagSearchEvent = (tagName: string) => {
		const searchAssetsEvent = new CustomEvent('react-overview_search-assets', {
			detail: {
				filters: { field: 'tags', value: tagName, filterType: 'add' }, // Only manual tags are displayed in spotlight results, no autotags
			},
		});

		window.dispatchEvent(searchAssetsEvent);
	};

	const onTagClick = (e: React.MouseEvent, tagName: string | number) => {
		e.preventDefault();
		const reactAssetOverviewIsActive = isReactAssetOverviewActive();

		if (reactAssetOverviewIsActive) {
			emitTagSearchEvent(tagName.toString());
		} else {
			document.location.href = `/search/set/?field=tags&value=${encodeURIComponent(
				tagName,
			)}&filterType=add`;
		}

		clearSearchTerm();
	};

	return (
		<>
			<li className="spotlight-alltags">
				<a href="#" className="header no-click" onClick={onDisabledClick}>
					<IconTag size={iconSizeMedium} />
					{translate('tags.allTagsFor')} <b>{searchTerm}</b>
				</a>
			</li>
			<div className="spotlight-results" style={calculateHeightStyle(results)}>
				<ul>
					{tags.map((tagName, index) => {
						if (index % 2 !== 0) {
							return null;
						}

						const tagQty = tags[index + 1];

						return (
							<li
								className="spotlight-tag"
								data-value={tagName}
								onClick={(e) => onTagClick(e, tagName)}
								key={tagName}
							>
								<a href="#" className="no-click">
									<IconTag size={iconSizeMedium} /> {tagName}
									<span className="searchbox-info">{tagQty}</span>
								</a>
							</li>
						);
					})}
				</ul>
			</div>
		</>
	);
}

const onDisabledClick = (e: React.MouseEvent) => {
	e.stopPropagation();
	e.preventDefault();
};
